import { Vue } from "vue-property-decorator";
import "./skeleton.scss";

export class Skeleton extends Vue {}
